import type { LucideIcon } from "lucide-react";

export type IconTint =
  // Channel tints (used by Klaviyo/SMS/etc nav items + badges)
  | "neutral"
  | "klaviyo"
  | "sms"
  | "email"
  | "push"
  | "whatsapp"
  | "loyalty"
  | "helpdesk"
  // Semantic tints (used across the sidebar + KPI cards)
  | "scale"      // emerald — positive, "good news", actions queue
  | "insight"    // blue — analytics, audits, performance
  | "warm"       // orange — calendar, weekly cadence, promotions
  | "goal"       // violet — targets, ambition
  | "admin"      // purple — admin / superadmin surfaces
  | "subject";   // blue — copy / subject lab

const TINT_BG: Record<IconTint, string> = {
  // Channel tints map 1:1 to existing CSS tokens.
  neutral: "bg-bg-subtle text-text-secondary",
  klaviyo: "bg-channel-klaviyo-bg text-channel-klaviyo",
  sms: "bg-channel-sms-bg text-channel-sms",
  email: "bg-channel-email-bg text-channel-email",
  push: "bg-channel-push-bg text-channel-push",
  whatsapp: "bg-channel-whatsapp-bg text-channel-whatsapp",
  loyalty: "bg-bg-subtle text-text-secondary",
  helpdesk: "bg-bg-subtle text-text-secondary",
  // Semantic tints reuse the cat-* token palette so we don't duplicate
  // colors. Stays single-source: rebrand = swap CSS vars, not classNames.
  scale: "bg-cat-scale-bg text-cat-scale-fg",
  insight: "bg-cat-keyword-bg text-cat-keyword-fg",
  warm: "bg-cat-budget-bg text-cat-budget-fg",
  goal: "bg-cat-bid-bg text-cat-bid-fg",
  admin: "bg-channel-klaviyo-bg text-channel-klaviyo",
  subject: "bg-cat-subject-bg text-cat-subject",
};

export function IconBadge({
  icon: Icon,
  tint = "neutral",
  size = 14,
}: {
  icon: LucideIcon;
  tint?: IconTint;
  size?: number;
}) {
  return (
    <span
      className={`inline-flex items-center justify-center w-[22px] h-[22px] rounded-md shrink-0 ${TINT_BG[tint]}`}
      aria-hidden
    >
      <Icon size={size} strokeWidth={1.75} />
    </span>
  );
}
